import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_HOME_REQUEST = 'farmakom/homeProducts/LOAD_HOME_REQUEST';
const LOAD_HOME_SUCCESS = 'farmakom/homeProducts/LOAD_HOME_SUCCESS';
const LOAD_HOME_FAILURE = 'farmakom/homeProducts/LOAD_HOME_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadHomeProducts() {
  return {
    [RSAA]: {
      ...api.getHomeProducts(),
      types: [LOAD_HOME_REQUEST, LOAD_HOME_SUCCESS, LOAD_HOME_FAILURE],
      bailout: (store) => store.homeProducts.data.discounted && store.homeProducts.data.discounted.length > 0
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: {
    discounted: [],
    latest: [],
    bestsellers: [],
    tags: []
  }
};

export default function homeProductsReducer (state = initialState, action) {
  switch(action.type) {
    case LOAD_HOME_REQUEST:
      return {
        ...state,
        loading: true
      }
		case LOAD_HOME_SUCCESS:
			return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }
    case LOAD_HOME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message
      }
      default:
  			return state;
  	}
  }
